/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './notifications.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../$$_gendir/node_modules/primeng/components/growl/growl.ngfactory';
import * as i3 from 'primeng/components/dom/domhandler';
import * as i4 from 'primeng/components/growl/growl';
import * as i5 from 'primeng/components/common/messageservice';
import * as i6 from '../../../../$$_gendir/node_modules/primeng/components/messages/messages.ngfactory';
import * as i7 from 'primeng/components/messages/messages';
import * as i8 from '../../../../app/theme/notifications/notifications.component';
import * as i9 from '../../../../app/theme/services/notifications/notifications.service';
const styles_NotificationsComponent:any[] = [i0.styles];
export const RenderType_NotificationsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NotificationsComponent,data:{}});
export function View_NotificationsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'p-growl',[['life',
      '3000']],(null as any),(null as any),(null as any),i2.View_Growl_0,i2.RenderType_Growl)),
      i1.ɵprd(512,(null as any),i3.DomHandler,i3.DomHandler,([] as any[])),i1.ɵdid(2,
          4636672,(null as any),0,i4.Growl,[i1.ElementRef,i3.DomHandler,i1.IterableDiffers,
              [2,i5.MessageService]],{sticky:[0,'sticky'],life:[1,'life'],value:[2,
              'value']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
          i1.ɵeld(4,0,(null as any),(null as any),1,'p-messages',([] as any[]),(null as any),
              (null as any),(null as any),i6.View_Messages_0,i6.RenderType_Messages)),
      i1.ɵdid(5,180224,(null as any),0,i7.Messages,[[2,i5.MessageService]],{value:[0,
          'value']},(null as any))],(_ck,_v) => {
    var _co:i8.NotificationsComponent = _v.component;
    const currVal_0:any = false;
    const currVal_1:any = '3000';
    const currVal_2:any = _co.growl;
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = _co.message;
    _ck(_v,5,0,currVal_3);
  },(null as any));
}
export function View_NotificationsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-notifications',
      ([] as any[]),(null as any),(null as any),(null as any),View_NotificationsComponent_0,
      RenderType_NotificationsComponent)),i1.ɵdid(1,245760,(null as any),0,i8.NotificationsComponent,
      [i9.NotificationsService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const NotificationsComponentNgFactory:i1.ComponentFactory<i8.NotificationsComponent> = i1.ɵccf('app-notifications',
    i8.NotificationsComponent,View_NotificationsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL25vdGlmaWNhdGlvbnMvbm90aWZpY2F0aW9ucy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL25vdGlmaWNhdGlvbnMvbm90aWZpY2F0aW9ucy5jb21wb25lbnQudHMiLCJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvdGhlbWUvbm90aWZpY2F0aW9ucy9ub3RpZmljYXRpb25zLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL25vdGlmaWNhdGlvbnMvbm90aWZpY2F0aW9ucy5jb21wb25lbnQudHMuTm90aWZpY2F0aW9uc0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxwLWdyb3dsIFtzdGlja3ldPVwiZmFsc2VcIiBsaWZlPVwiMzAwMFwiIFt2YWx1ZV09XCJncm93bFwiPjwvcC1ncm93bD5cclxuPHAtbWVzc2FnZXMgW3ZhbHVlXT1cIm1lc3NhZ2VcIj48L3AtbWVzc2FnZXM+IiwiPGFwcC1ub3RpZmljYXRpb25zPjwvYXBwLW5vdGlmaWNhdGlvbnM+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO2FBQUEscUVBQUE7VUFBQTtjQUFBO2NBQUEseUJBQWdFLDBDQUNoRTtpQkFBQTtjQUFBO2FBQUE7VUFBQTs7SUFEUztJQUFpQjtJQUFZO0lBQXRDLFdBQVMsVUFBaUIsVUFBWSxTQUF0QztJQUNZO0lBQVosV0FBWSxTQUFaOzs7O29CQ0RBO01BQUE7dUNBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/theme/notifications/notifications.component.ngfactory.ts